/* unplugin-vue-components disabled */import { render } from "./PopupPicker.vue?vue&type=template&id=8d06c632&ts=true"
import script from "./PopupPicker.vue?vue&type=script&lang=ts"
export * from "./PopupPicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__